import React, {useContext} from 'react'
import { Text, LanguageContext } from '../../../containers/Language';
import './Subscribe.scss';

const Subscribe = () => {

    const {dictionary}= useContext(LanguageContext);

    return (
        <>
            {/* <div className={classes.emailForm}>
                <label>Yeniliklərimizə abunə olun</label>
                <div className={classes.innerForm}>
                    <input type='text' placeholder='E-mailinizi daxil edin' />
                    <button className='btn btn-primary'>Abunə olun</button>
                </div>
            </div> */}

          

            <div class="sp-form-outer sp-force-hide">
                    <div id="sp-form-188994" sp-id="188994"
                        sp-hash="bf01353b7f17d98f80d844b804e61e5f21c8ec79e87948567e31449a4ae9f838" sp-lang="en"
                        class="sp-form sp-form-regular sp-form-embed sp-form-horizontal"
                        sp-show-options="%7B%22satellite%22%3Afalse%2C%22maDomain%22%3A%22login.sendpulse.com%22%2C%22formsDomain%22%3A%22forms.sendpulse.com%22%2C%22condition%22%3A%22onScroll%22%2C%22scrollTo%22%3A100%2C%22delay%22%3A0%2C%22repeat%22%3A3%2C%22background%22%3A%22rgba(0%2C%200%2C%200%2C%200.5)%22%2C%22position%22%3A%22bottom-center%22%2C%22animation%22%3A%22%22%2C%22hideOnMobile%22%3Afalse%2C%22urlFilter%22%3Afalse%2C%22urlFilterConditions%22%3A%5B%7B%22force%22%3A%22hide%22%2C%22clause%22%3A%22contains%22%2C%22token%22%3A%22%22%7D%5D%2C%22analytics%22%3A%7B%22ga%22%3A%7B%22eventLabel%22%3A%22Landing_Page_Subs%22%2C%22send%22%3Atrue%7D%2C%22ym%22%3A%7B%22counterId%22%3A56379571%2C%22eventLabel%22%3Anull%2C%22targetId%22%3Anull%2C%22send%22%3Afalse%7D%7D%2C%22utmEnable%22%3Atrue%7D">
                        <div class="sp-form-fields-wrapper">
                            <div class="sp-message">
                                <div></div>
                            </div>
                            <form novalidate="" class="sp-element-container ">
                                <div class="sp-field sp-field-full-width"
                                    sp-id="sp-30dad777-18ed-4590-b03f-d2f8203102b3">
                                    <div
                                        >
                                        <p><span><Text tid="SUBSCRIBE_TO_NEWS"/></span></p>
                                    </div>
                                </div>
                                <div class="sp-field " sp-id="sp-6b80daa2-af5c-4ce8-a1ac-8f5f324267cc"><label
                                        class="sp-control-label"><span>e-mail</span><strong>*</strong></label><input
                                        type="email" sp-type="email" name="sform[email]" class="sp-form-control" 
                                        placeholder={dictionary.ENTER_EMAIL} autoComplete='off'
                                        sp-tips="%7B%22required%22%3A%22Required%20field%22%2C%22wrong%22%3A%22Wrong%20email%22%7D"
                                        required="required"/></div>
                                <div class="sp-field sp-button-container "
                                    sp-id="sp-03ac1dfe-04c3-4a1f-881a-348a00212af8"><button
                                        id="sp-03ac1dfe-04c3-4a1f-881a-348a00212af8" class="sp-button"><Text tid="SUBSCRIBE" />
                                    </button></div>
                            </form>
                            <div class="sp-link-wrapper sp-brandname__left"></div>
                        </div>
                    </div>
                </div>
        </>

    )
}

export default Subscribe
